/**
 * nt = “no translate”.
 * It returns the text unchanged at run time avoid the Linter error
 */
export function nt(text: string): string {
  return text;
}
